<div class="timeline">
  <div class="timeline-header">
    <span class="timeline-stat"><b>{{ total }}</b> alerts</span>
    <span class="timeline-stat">peak <b>{{ peak }}</b></span>
    <span class="timeline-stat">bucket <b>{{ bucketLabel }}</b></span>
    <ng-content select="[timelineStats]"></ng-content>
    @if (showLegend && data?.series?.length) {
      <span class="timeline-legend">
        @for (series of data.series; track series.label) {
          <span class="legend-item"><i class="legend-dot" [style.background]="series.color"></i>{{ series.label }}</span>
        }
      </span>
    }
    @if (selection) {
      <button type="button" class="btn btn-link timeline-clear" (click)="clearSelection()"><svg-icon key="close" [fontSize]="10" />Clear selection</button>
    }
  </div>
  <div class="timeline-canvas" [style.height]="height" [class.selectable]="selectable">
    <canvas
      #canvas
      (pointerdown)="onPointerDown($event)"
      (pointermove)="onPointerMove($event)"
      (pointerup)="onPointerUp($event)"
      (pointerleave)="onPointerLeave()"
    ></canvas>
  </div>
  @if (selectable) {
    <p class="timeline-hint">Click a bar or drag across bars to narrow the list to that time.</p>
  }
</div>
